import type { Step } from './useHowItWorks';

type StepCardProps = {
  step: Step;
};

const StepCard = ({ step }: StepCardProps) => {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-accent-primary">
        <span className="font-heading text-3xl font-semibold text-surface-inverse">
          {step.number}
        </span>
      </div>
      <h3 className="font-heading text-2xl font-medium text-foreground-primary">
        {step.title}
      </h3>
      <p className="font-body text-base leading-relaxed text-foreground-secondary">
        {step.description}
      </p>
    </div>
  );
};

export default StepCard;
